import { IPublicClientApplication } from '@azure/msal-browser'
import {
  Button,
  Group,
  LoadingOverlay,
  Modal,
  Stack,
  Text,
  Textarea,
} from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { useState } from 'react'
import { reportLocation } from '../../data/location.service'

interface ReportLocationModalProps {
  opened: boolean
  onClose: () => void
  locationId: number
  instance: IPublicClientApplication
}

const ReportLocationModal = ({
  opened,
  onClose,
  locationId,
  instance,
}: ReportLocationModalProps) => {
  const [reportReason, setReportReason] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async () => {
    if (!reportReason.trim()) return

    setIsSubmitting(true)
    try {
      await reportLocation(locationId, reportReason, instance)
      notifications.show({
        title: 'Report Submitted',
        message:
          'Thank you for reporting this incorrect information. We will review it shortly.',
        color: 'green',
      })
      setReportReason('')
      onClose()
    } catch (error: any) {
      notifications.show({
        title: 'Error',
        message:
          'Failed to report incorrect information. Please try again later.',
        color: 'red',
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title='Report Incorrect Information'
      centered
      size='md'
      radius='lg'
    >
      <Stack pos='relative'>
        {isSubmitting && <LoadingOverlay />}
        <Text>What information is incorrect?</Text>
        <Textarea
          placeholder='The business hours are not correct.'
          value={reportReason}
          onChange={(e) => setReportReason(e.target.value)}
          rows={5}
          disabled={isSubmitting}
        />
        <Group justify='flex-end' mt='md'>
          <Button
            onClick={handleSubmit}
            loading={isSubmitting}
            disabled={isSubmitting || !reportReason.trim()}
          >
            Submit Report
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}

export default ReportLocationModal
